import { render, staticRenderFns } from "./friendMessageList.vue?vue&type=template&id=2158ceb8&scoped=true&"
import script from "./friendMessageList.vue?vue&type=script&lang=js&"
export * from "./friendMessageList.vue?vue&type=script&lang=js&"
import style0 from "./friendMessageList.vue?vue&type=style&index=0&id=2158ceb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2158ceb8",
  null
  
)

export default component.exports